import { Client } from '../../types/menu';
import { WithClassname } from '../../types';
import useProductIdentifiers from '../../hooks/menu/useProductIdentifiers';
import React from 'react';
import classnames from 'classnames';

type Props = WithClassname & {
  product: Client.Product;
};

export default function ProductIdentifiers({ product, className }: Props) {
  const { names } = useProductIdentifiers(product);

  return (
    names.isNotEmpty() && (
      <div className={classnames('py-xs px-xs w-fit rounded-lg bg-gray', className)}>
        <p className="text-xs text-gray-700 lowercase">{names.implode(' · ')}</p>
      </div>
    )
  );
}
